"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M16 7H8v8h2v7h4v-7h2zm-4-5.2486L14.2486 4 12 6.2486 9.7514 4z"
}), 'Man3Sharp');